import { useQuery } from "@tanstack/react-query";

import { QUERY_KEYS } from "@api/queryKeys";

import { aiAdvisorApi } from "./aiAdvisor.service";

export const useAIAdvisorQuery = (pressId: string) => {
  const query = useQuery({
    queryKey: [QUERY_KEYS.aiAdvisor],
    queryFn: () => aiAdvisorApi.getAiAdvisorData(pressId),
    throwOnError: false,
  });

  return query;
};
